// the stat box Alpine object
window.appCheckboxSelect = (name, initialLabel, items) => {
    return {
        name,
        initialLabel,
        items,
        label: '',
        subName: null,
        expanded: false,
        onChange: null,
        selectedItems: [],
        init: function() {
            this.label = this.initialLabel;

            // if this is a nested object as part of inputs, or just a plain store object
            if( this.name.includes('inputs.')) {
                const parts = this.name.split('.');
                this.subName = parts[1];
                this.$store.inputs.set(this.subName, []);
                this.$store.inputs.set(this.subName + 'Total', 0);
            } else {
                this.$store[name] = [];
                this.$store[name + 'Total'] = 0;
            }

            this.updateSelectedItems();
        },
        set: function(item) {
            if(this.subName) {
                // work with an object to stop Alpine refreshing each time it changes
                let p = [...this.$store.inputs.current[this.subName]];

                // Already selected, then remove
                if( this.isSelected(item.value) ) {
                    p = p.filter( v => v != item.value );

                // otherwise add it if there is room
                } else {
                    p = [...p,item.value];
                }

                // update store
                this.$store.inputs.set(this.subName, p);
                this.$store.inputs.set(this.subName + 'Total', p.length);
            } else {
                // Already selected, then remove
                if( this.isSelected(item.value) ) {
                    this.$store[name] = this.$store[name].filter( v => v != item.value );
                    this.$store[name + 'Total']--;
                // otherwise add it if there is room
                } else {
                    this.$store[name].push( item.value );
                    this.$store[name + 'Total']++;
                }
            }

            // additional callback, if registered to handle items
            if(this.onChange) {
                this.onChange()
            }

            //update selected items for this component
            this.updateSelectedItems();
        },
        clearAll: function() {
            if(this.subName) {
                this.$store.inputs.set(this.subName, []);
                this.$store.inputs.set(this.subName + 'Total', 0);
            } else {
                this.$store[name] = [];
                this.$store[name + 'Total'] = 0;
            }
            this.expanded = false;
            this.updateSelectedItems();

            // additional callback, if registered to handle items
            if(this.onChange) {
                this.onChange()
            }
        },
        isSelected: function( value ) {
            if(this.subName) {
                let p = [...this.$store.inputs.current[this.subName]];
                return p.findIndex(v => v == value) !== -1;
            } else {
                return this.$store[name].findIndex(v => v == value) !== -1;
            }
        },
        // as this is called a lot from the HTML speed up performance by remembering values
        updateSelectedItems: function() {
            this.selectedItems = [];
            this.items.forEach(item => {
                this.selectedItems[item.value] = this.isSelected(item.value);
            })
        }
    }
};
